import { render, staticRenderFns } from "./MapaSalaDoEmpreendedor.vue?vue&type=template&id=39d31dac"
import script from "./MapaSalaDoEmpreendedor.vue?vue&type=script&lang=js"
export * from "./MapaSalaDoEmpreendedor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports